// Inicializa EmailJS
(function() {
    emailjs.init('_Cz9MMeh1XGOb2JfS');
})();

const emailConfig = {
    serviceID: 'service_c7qmf7q',
    templateID: 'template_8q753n6',
    userID: '_Cz9MMeh1XGOb2JfS'
};

function getNextOrderNumber() {
    let orderNumber = localStorage.getItem('orderNumber');
    orderNumber = orderNumber ? parseInt(orderNumber) + 1 : 1000;
    localStorage.setItem('orderNumber', orderNumber);
    return orderNumber;
}

function getUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        utm_source: urlParams.get('utm_source') || 'Desconhecido',
        utm_medium: urlParams.get('utm_medium') || 'Desconhecido',
        utm_campaign: urlParams.get('utm_campaign') || 'Desconhecido',
        utm_content: urlParams.get('utm_content') || 'Desconhecido'
    };
}

function sendOrderEmail(orderDetails, customerDetails, utmParams) {
    const templateParams = {
        order_number: orderDetails.orderNumber,
        order_details: orderDetails.items,
        customer_email: customerDetails.email,
        customer_name: customerDetails.name,
        customer_address: customerDetails.address,
        customer_number: customerDetails.number,
        customer_complement: customerDetails.complement,
        customer_neighborhood: customerDetails.neighborhood,
        customer_phone: customerDetails.phone,
        customer_observation: customerDetails.observation,
        payment_method: customerDetails.paymentMethod,
        troco: customerDetails.troco,
        delivery_fee: customerDetails.deliveryFee.toFixed(2),
        total: customerDetails.total.toFixed(2),
        utm_source: utmParams.utm_source,
        utm_medium: utmParams.utm_medium,
        utm_campaign: utmParams.utm_campaign,
        utm_content: utmParams.utm_content
    };

    emailjs.send(emailConfig.serviceID, emailConfig.templateID, templateParams, emailConfig.userID)
    .then(response => {
        console.log('SUCCESS!', response.status, response.text);
        alert('Pedido recebido, aguarde a CONFIRMAÇÃO do estabelecimento!');
    }, error => {
        console.error('FAILED...', error);
        alert('Erro ao enviar o pedido por email. Por favor, tente novamente mais tarde.');
    });
}

function finalizarPedido() {
    const selectedPayment = document.querySelector('input[name="payment"]:checked');
    if (!selectedPayment) {
        alert("Por favor, selecione uma opção de pagamento.");
        return;
    }
    
    const formaPagamento = selectedPayment.value;
    const nome = document.getElementById('name').value;
    const email = document.getElementById('customerEmail').value;
    const endereco = document.getElementById('address').value;
    const numero = document.getElementById('number').value;
    const complemento = document.getElementById('complement').value;
    const bairro = document.getElementById('neighborhood').value;
    const telefone = document.getElementById('phone').value;
    const observacao = document.getElementById('obs').value;
    const necessitaTroco = document.getElementById('troco').value;
    let valorTroco = necessitaTroco === 'sim' ? document.getElementById('valorTroco').value : '';
    
    let mensagemPedido = "";
    let orderDetails = "";
    const menuItens = document.querySelectorAll('.menu-item');
    let totalPedido = 0;
    
    menuItens.forEach(item => {
        const quantidade = parseInt(item.querySelector('.quantity').innerText);
        if (quantidade > 0) {
            const nomeItem = item.querySelector('h3, h4').innerText;
            const precoUnitario = parseFloat(item.querySelector('.item-price').getAttribute('data-price'));
            const precoTotal = quantidade * precoUnitario;
            mensagemPedido += `${quantidade}x ${nomeItem} - R$ ${precoTotal.toFixed(2)}\n`;
            orderDetails += `${quantidade}x ${nomeItem} - R$ ${precoTotal.toFixed(2)}<br>`;
            totalPedido += precoTotal;
        }
    });
    
    const taxaEntrega = window.valorFreteGlobal || 0;
    totalPedido += taxaEntrega;
    
    if (totalPedido > taxaEntrega) {
        const orderNumber = getNextOrderNumber();
        mensagemPedido = `Pedido #${orderNumber}\n\n` + mensagemPedido;
        mensagemPedido += `\nTaxa de entrega: R$ ${taxaEntrega.toFixed(2)}`;
        mensagemPedido += `\nTotal (incluindo taxa de entrega): R$ ${totalPedido.toFixed(2)}`;
        
        mensagemPedido += `\n\n📌 *Endereço de entrega:*`;
        mensagemPedido += `\n👤 Nome: ${nome}`;
        mensagemPedido += `\n🏠 ${endereco}, Nº ${numero}`;
        if (complemento) mensagemPedido += `\n📌 Complemento: ${complemento}`;
        mensagemPedido += `\n🏙️ Bairro: ${bairro}`;
        mensagemPedido += `\n📞 Telefone: ${telefone}`;
        mensagemPedido += `\n💰 Forma de pagamento: ${formaPagamento}`;
        mensagemPedido += `\n📝 Observação: ${observacao}`;
        if (necessitaTroco === 'sim') {
            mensagemPedido += `\n💵 Troco para: R$ ${valorTroco}`;
        }
        
        const numeroWhatsApp = "5524992798893";
        const apiURL = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensagemPedido)}`;
        window.location.href = apiURL;

        
        const customerDetails = {
            email, name: nome, address: endereco, number: numero, complement: complemento,
            neighborhood: bairro, phone: telefone, observation: observacao, paymentMethod: formaPagamento,
            troco: necessitaTroco === 'sim' ? `Sim, R$ ${valorTroco}` : 'Não', deliveryFee: taxaEntrega, total: totalPedido
        };
        
        const utmParams = getUTMParams();
        sendOrderEmail({ items: orderDetails, orderNumber }, customerDetails, utmParams);
    } else {
        alert("Seu carrinho está vazio. Adicione itens antes de finalizar o pedido.");
    }
}
